import React, { ReactElement } from 'react';
import { NavigationButtons } from '../../shared/NavigationButtons';
import { Form, Formik } from 'formik';
import { CoverageCheckupState, goToNextStep, updateCoverageCheckupState } from '../../../store/step';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { DisabilityInsuranceTypeStepForm } from './DisabilityInsuranceTypeStepForm';
import { disabilityInsuranceTypeSchema } from '../../schema';
import { CardPadding } from '../../shared/CardStyles';
import { CardHeader } from '../../shared/CardStyles/CardHeader';
import { useFormInteractionTracking } from '../../../hooks/useFormInteractionTracking';

function DisabilityInsuranceTypeStep(): ReactElement {
  const dispatch = useDispatch();
  const {
    typeOfDisabilityInsurancePossessed: typeOfDisabilityInsurancePossessed,
  } = useSelector((state: RootState) => state.steps);

  const formRef = useFormInteractionTracking('kind_of_disability');

  function onSubmit(values: Partial<CoverageCheckupState>): void {
    dispatch(updateCoverageCheckupState(values));
    dispatch(goToNextStep());
  }
  return (
    <CardPadding>
      <CardHeader
        header="What kind of disability insurance do you have?"
        subHeader="Short-term disability insurance usually covers you less than a year.
          Long-term usually covers anything over five years."
      />
      <Formik
        initialValues={{ typeOfDisabilityInsurancePossessed }}
        onSubmit={onSubmit}
        validationSchema={disabilityInsuranceTypeSchema}
      >
        <Form ref={formRef}>
          <DisabilityInsuranceTypeStepForm name="typeOfDisabilityInsurancePossessed" />
          <NavigationButtons />
        </Form>
      </Formik>
    </CardPadding>
  );
}

export { DisabilityInsuranceTypeStep };
